import styled from 'styled-components';
import { colors } from 'globalStyles';

export const PreviewScreen = styled.div`
  padding: 65px 0 28px !important;
  background-position: center !important;
`;

export const BackgroundImg = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 250.13px;
  height: 333.97px;
  margin: 36.28px 18.16px 35.96px 18.17px;
  z-index:0;

  &.pro {
    position: absolute;
    top: 0;
    left: 0;
    width: 266.13px;
    height: 381.97px;
    margin: 19.28px 16.16px 35.96px 16.17px;
    z-index: 0;
  }
`;

export const LogoImg = styled.img`
  width: 190.125px;
  height: 117px;
`;

export const LogoWrapper = styled.div`
  width: 190.125px;
  height: 117px;
  margin: 0px auto 13px;
  z-index: 1;
  position: relative;
`;

export const Title = styled.div`
  font-size: 11px;
  font-weight: 800;
  font-family: Proxima Nova;
  text-align: center;
  line-height: 13px;
  z-index: 1;
  position: relative;
`;

export const ButtonWrapper = styled.div`
  margin-top: 50px;
  position: relative;

  &.pro {
    margin-top: 130px
  }
`;

export const PlaceholderWrapper = styled.div`
  border: 0.56px solid ${colors.WHITE};
  height: 100%;
  width: 100%;
  padding-top: 36px;
  z-index: 1;
`;

export const PlaceholderText = styled.div`
  color: ${colors.WHITE};
  font-family: "Proxima Nova";
  font-size: 48px;
  font-weight: 600;
  line-height: 48px;
  font-weight: normal;
  text-align: center;
`;


